import { memo } from "react";
import { shallow } from "zustand/shallow";

import useGlobalState from "../use-global-state.js";
import { Footer as FooterComponent } from "../tctt.js";
import logo from "../assets/images/isselLogo.png";
import { theme } from "../theme.js";

const Footer = () => {
	const { maxDSLScreen } = useGlobalState((e) => ({
		maxDSLScreen: e.maxDSLScreen,
	}), shallow);

	if (maxDSLScreen) {
		return null;
	}

	return (
		<FooterComponent
			height="60px"
			backgroundColor="dark"
			backgroundColorLight="main"
			targetUrl="https://issel.ee.auth.gr"
			logo={logo}
			text={`@${(new Date()).getFullYear()} ISSEL | All Rights Reserved`}
			customTheme={theme}
			containerWidth="1200px"
			textColor="#fff"
		/>
	);
};

export default memo(Footer);